import { render, staticRenderFns } from "./DialogInformativoLimiteCreditoPontoVendaExcedido.vue?vue&type=template&id=dc0615e0&scoped=true&"
import script from "./DialogInformativoLimiteCreditoPontoVendaExcedido.vue?vue&type=script&lang=js&"
export * from "./DialogInformativoLimiteCreditoPontoVendaExcedido.vue?vue&type=script&lang=js&"
import style0 from "./DialogInformativoLimiteCreditoPontoVendaExcedido.vue?vue&type=style&index=0&id=dc0615e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0615e0",
  null
  
)

export default component.exports